// Import Packages
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from 'recoil';

// Import Material UI
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Check from "@material-ui/icons/Check";
import CheckIcon from "@material-ui/icons/Check";
import StepConnector from "@material-ui/core/StepConnector";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import { FormControlLabel, OutlinedInput } from "@material-ui/core";
// Import Packages
import TextField from "../../../../components/TextField/TextField";
import WebHookForm from "../../automs/webHook/WebHookForm";
import Button from "../../../../components/Button/Button";
import { GreenCheckbox } from "../../../../components/FlowConfigurationInputs";
import Modal from "../../../../components/Modal/Modal";
import triggerService from "../../../../services/triggerService/triggerService";
import { alertState } from "../../../../recoil-store/recoil-state";

// Import Helpers

import { checkSpecialCharacter } from '../../../../helpers/helper';

const useQontoStepIconStyles = makeStyles({
    root: {
        color: "#eaeaf0",
        display: "flex",
        height: 22,
        alignItems: "center",
    },
    active: {
        color: "#784af4",
    },
    circle: {
        width: 8,
        height: 8,
        borderRadius: "50%",
        backgroundColor: "currentColor",
    },
    completed: {
        color: "#784af4",
        zIndex: 1,
        fontSize: 18,
    },
});

function QontoStepIcon(props) {
    const classes = useQontoStepIconStyles();
    const { active, completed } = props;

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
            })}
        >
            {completed ? (
                <Check className={classes.completed} />
            ) : (
                <div className={classes.circle} />
            )}
        </div>
    );
}

QontoStepIcon.propTypes = {
    /**
     * Whether this step is active.
     */
    active: PropTypes.bool,
    /**
     * Mark the step as completed. Is passed to child components.
     */
    completed: PropTypes.bool,
};

const ColorlibConnector = withStyles({
    alternativeLabel: {
        top: 22,
        marginLeft: -10
    },
    active: {
        "& $line": {
            background: "#5AC384",
        },
    },
    completed: {
        "& $line": {
            background: "#5AC384",
        },
    },
    line: {
        height: 3,
        border: 0,
        backgroundColor: "#eaeaf0",
        borderRadius: 1,
    },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
    root: {
        backgroundColor: "#ccc",
        zIndex: 1,
        color: "#fff",
        width: 50,
        height: 50,
        display: "flex",
        borderRadius: "50%",
        justifyContent: "center",
        alignItems: "center",
    },
    active: {
        background: "#5AC384",
        boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
    },
    completed: {
        background: "#5AC384",
    },
});

function ColorlibStepIcon(props) {
    const classes = useColorlibStepIconStyles();
    const { active, completed } = props;

    const icons = {
        1: "1",
        2: "2",
        3: "3",
    };
    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
                [classes.completed]: completed,
            })}
        >
            {completed ? <CheckIcon /> : icons[String(props.icon)]}
        </div>
    );
}

ColorlibStepIcon.propTypes = {
    /**
     * Whether this step is active.
     */
    active: PropTypes.bool,
    /**
     * Mark the step as completed. Is passed to child components.
     */
    completed: PropTypes.bool,
    /**
     * The label displayed in the step icon.
     */
    icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        padding: "0 !important",
    },
    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}));

function getSteps() {
    return ["DETAILS", "RULE", "ADD-AUTOM"];
}

const checkTextRule = (e, handleChange) => {
    if (e.target.value !== ' ') {
        handleChange(e);
    }
}

function getStepContent(
    step,
    value,
    handleChange,
    t,
    rules,
    setRules,
    action,
    state,
    setState,
    automs
) {
    switch (step) {
        case 0:
            return (
                <div style={{ marginLeft: 32, marginBottom: 32 }}>
                    <div className="form-element">
                        <div style={{ marginBottom: 3 }}>
                            {t("CONTENT.WEBHOOK.WEBHOOK-RULE-NAME")}
                        </div>
                        <TextField
                            name="name"
                            width={"90%"}
                            required={true}
                            value={value.name}
                            onChange={(e) => checkTextRule(e, handleChange)}
                        />
                    </div>
                    <div className="form-element">
                        <div style={{ marginBottom: 3 }}>
                            {t("CONTENT.WEBHOOK.DESCRIPTION")}
                        </div>
                        <TextField
                            name="description"
                            required={true}
                            multiline={true}
                            rows={"8"}
                            width={"90%"}
                            value={value.description}
                            onChange={(e) => checkTextRule(e, handleChange)}
                        />
                    </div>
                </div>
            );
        case 1:
            return (<div style={{ paddingLeft: 30, paddingRight: 0 }}>
                <WebHookForm
                    action={action}
                    rules={rules}
                    setRules={setRules}
                    isHeader={false}
                    isVariableAdd={false}
                />
            </div>
            );
        case 2:
            return <div style={{ paddingLeft: 30, paddingRight: 10 }}><AutomList state={state} automs={automs} setState={setState} t={t} /></div>
        default:
            return "Unknown step";
    }
}

function CustomizedSteppers({
    rules,
    handleChange,
    header,
    setRules,
    action,
    setState,
    state,
    setOpen,
    setRefresh,
    openAdd,
    automs
}) {
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(0);
    const steps = getSteps();
    const { t } = useTranslation();
    let isCursor = "pointer";
    let isDisabled = false;
    const setAlert = useSetRecoilState(alertState);
    const messageLabel = 'MESSAGES.WEBHOOK.';

    const handleNext = () => {
        if (activeStep === 0) {
            if (checkSpecialCharacter(header.name)) {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t(messageLabel + "RULE-NAME-SPEACIAL-CHARACTERS"),
                    severity: 'error'
                }));
                return;
            } else if (header.name.trim().length < 3) {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t('CONTENT.WEBHOOK.RULE-NAME-LENGTH'),
                    severity: 'error'
                }));
                return;
            }
        }
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    // const handleReset = () => {
    //     setActiveStep(0);
    // };
    const editInputValue = () => {
        const newData = {
            period: "",
            name: header.name,
            description: header.description,
            private: false,
            configuration: rules,
            automs: state.list,
            type: "WEBHOOK",
        };
        if (openAdd?.type === "edit") {
            delete newData.automs;
        }

        return newData;
    }

    const handleSave = async () => {

        const response = await triggerService.createRule(editInputValue());
        if (response) {
            if (response?.status) {
                //success
                setRefresh(oldState => !oldState);
                setOpen(false);
            }
            setAlert(alert => ({ ...alert, show: true, message: t(messageLabel + response.message), severity: response.status ? 'success' : 'error' }))
        }
    };

    const handleEdit = async () => {

        let filter = automs?.map(itm => itm.id);

        let createData = state.list.filter(x => !filter.includes(x));
        let removeData = filter.filter(x => !state.list.includes(x));
        let data = editInputValue();

        data.deleteAutoms = removeData;
        data.createAutoms = createData;
        const result = await triggerService.updateRule(openAdd?.id, data);
        if (result.status) {
            setRefresh(oldState => !oldState);
            setOpen(false);
        }
        setAlert(alert => ({ ...alert, show: true, message: t(messageLabel + result.message), severity: result.status ? 'success' : 'error' }))
    }

    if (activeStep === 0) {
        if ((header?.name?.length === 0 || header?.description?.length === 0)) {
            isCursor = "not-allowed";
            isDisabled = true
        }
        else {
            isCursor = "pointer";
            isDisabled = false
        }
    } else if (activeStep === 1) {
        if (rules?.length === 0) {
            isCursor = "not-allowed";
            isDisabled = true
        }
        else {
            isCursor = "pointer";
            isDisabled = false
        }
    }
    return (
        <div className={classes.root}>
            <Stepper
                classes={{
                    root: classes.root,
                }}
                alternativeLabel
                activeStep={activeStep}
                connector={<ColorlibConnector />}
            >
                {steps.map((label, index) => (
                    <Step key={label} >
                        <StepLabel StepIconComponent={ColorlibStepIcon} style={{ marginLeft: index !== steps?.length - 1 && (index === 0 ? -25 : -20) }} >
                            <div style={{
                                color: "#8F94A6",
                                fontSize: 11,
                                marginTop: -10,
                                marginBottom: 10,
                                fontWeight: 600
                            }}>{t("CONTENT.WEBHOOK." + label).toUpperCase()}</div>
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>

            <div>
                <div className={classes.instructions}>
                    {getStepContent(
                        activeStep,
                        header,
                        handleChange,
                        t,
                        rules,
                        setRules,
                        action,
                        state,
                        setState,
                        automs
                    )}
                </div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginRight: 38,
                        marginLeft: 33,
                        marginBottom: 10
                    }}
                >
                    <Button
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        value={t("CONTENT.WEBHOOK.BACK")}
                        bgColor={"#fff"}
                        cursor={activeStep === 0 ? "not-allowed" : "pointer"}
                        border={"1px solid #031226"}
                        color={"#031226"}
                    />
                    <Button
                        onClick={activeStep === steps.length - 1 ? (openAdd?.type === "edit" ? handleEdit : handleSave) : handleNext}
                        disabled={isDisabled}
                        cursor={isCursor}
                        value={
                            activeStep === steps.length - 1
                                ? openAdd?.type === "edit" ? t("CONTENT.WEBHOOK.EDIT-RULE") : t("CONTENT.WEBHOOK.ADD-RULE")
                                : t("CONTENT.WEBHOOK.NEXT")
                        }
                    />
                </div>
            </div>
        </div>
    );
}

export const AutomList = ({ state, setState, t, automs }) => {
    const [searchData, setSearchData] = useState([]);
    const [data, setData] = useState([]);
    const [searchVal, setSearchVal] = useState("");
    const handleSearch = (event) => {
        setSearchVal(event.target.value);
        setSearchData(
            data.filter((autom) =>
                autom.name.toLowerCase().includes(event.target.value.toLowerCase())
            )
        );
    };
    useEffect(() => {
        const fetchData = async () => {
            const response = await triggerService.getUnassignedAutoms();
            if (response) {
                if (response?.data) {
                    if (Array.isArray(response?.data)) {
                        let newData = [];
                        if (automs?.length > 0) {
                            newData.push(...automs, ...response?.data);
                            setData(newData);
                            setSearchData(newData);
                        } else {
                            setData(response.data);
                            setSearchData(response.data);
                        }
                    } else {
                        if (automs?.length > 0) {
                            setData(automs);
                            setSearchData(automs);
                        }
                    }
                }
            }
        };
        fetchData().then((r) => r);
    }, []);

    const handleCheck = (e, item) => {
        if (!item) {
            if (data.length !== state.list.length) {
                state.list = [];
                for (const iter of data) {
                    state.list.push(iter.id);
                }
            } else {
                state.list = [];
            }
        } else if (e.target.checked) {
            state.list.push(item.id);
        } else {
            state.list.splice(
                state.list.findIndex((id) => id === item.id),
                1
            );
        }
        setState({ ...state });
    };
    return (
        <>
            <div className="form-element" style={{ width: "90%" }}>
                <OutlinedInput
                    id="outlined-adornment-amount"
                    className="searchbar-input"
                    style={{ border: "1px solid #DDDDDD" }}
                    value={searchVal}
                    placeholder="Search..."
                    onChange={(event) => handleSearch(event)}
                    startAdornment={
                        <InputAdornment position="start">
                            <SearchIcon className="searchbar-icon" />
                        </InputAdornment>
                    }
                />
            </div>
            <div>
                {searchData.length > 0 && (
                    <button
                        className="user-detail-link"
                        onClick={handleCheck}
                        style={{
                            color: "#6D6D6D",
                            position: "absolute",
                            right: 40,
                            marginTop: -10,
                        }}
                    >
                        (
                        {searchData.length !== state.list.length
                            ? t("CONTENT.QUEUE-POOL.SELECT-ALL")
                            : t("CONTENT.QUEUE-POOL.DESELECT-ALL")}
                        )
                    </button>
                )}
            </div>
            <div
                className="form-element email-trigger-scroll"
                style={{ marginLeft: 10, maxHeight: 250, overflowY: "auto" }}
            >
                {searchData?.map((item, index) => (
                    <div key={index}>
                        <FormControlLabel
                            label={<span className="sgeneral-day">{item.name}</span>}
                            control={
                                <GreenCheckbox
                                    checked={!!state.list?.includes(item.id)}
                                    onChange={(e) => handleCheck(e, item)}
                                    size="small"
                                />
                            }
                        />
                    </div>
                ))}
            </div>
        </>
    );
};
AutomList.propTypes = {
    setState: PropTypes.func,
    state: PropTypes.object,
};

const action = {
    fields: {
        name: { value: "" },
        description: { value: "" },
        sourceValue: { value: "" },
        operator: { value: "" },
        targetValue: { value: "" },
        params: { value: "" },
    },
};
const AddWebhookRule = (props) => {
    const { setOpen, openAdd } = props;
    const [rules, setRules] = useState([]);
    const [state, setState] = useState({ list: [] });
    const [automs, setAutoms] = useState([]);
    const [header, setHeader] = useState({
        name: "",
        description: "",
    });
    const setAlert = useSetRecoilState(alertState);

    useEffect(() => {
        if (openAdd?.type === "edit") {
            const fetchData = async () => {
                const { data } = await triggerService.getRuleById(openAdd.id);
                if (data) {
                    setHeader({ name: data.name, description: data.description });
                    setRules(data.configuration);
                    setAutoms(data.automs);
                    const automsFilterData = data?.automs.map(item => item.id);
                    setState({ list: automsFilterData });
                }
            }
            fetchData().then(r => r);
        }

    }, [])

    const handleChange = (event) => {
        setHeader({ ...header, [event.target.name]: event.target.value });
    };
    return (
        <Modal setOpen={setOpen} title="Add Rule" minWidth={460}>
            <CustomizedSteppers
                openAdd={openAdd}
                setRules={setRules}
                rules={rules}
                header={header}
                action={action}
                handleChange={handleChange}
                state={state}
                setState={setState}
                setOpen={setOpen}
                setRefresh={props.setRefresh}
                automs={automs}
            />
        </Modal>
    );
};

AddWebhookRule.propTypes = {
    setOpen: PropTypes.func,
    setRefresh: PropTypes.func,
    openAdd: PropTypes.object
};

export default AddWebhookRule;
